
import React from 'react';

interface FinalCTAProps {
  onNavigate?: (view: 'home' | 'pilot' | 'privacy' | 'terms') => void;
}

export const FinalCTA: React.FC<FinalCTAProps> = ({ onNavigate }) => {
  const BOOKING_URL = "https://outlook.office.com/bookwithme/user/00ab44e829054d0caf6074d9ffaa2153@groflex.ai/meetingtype/0S1TPXwvgk2Nip5dsFYVgQ2?anonymous&ismsaljsauthenabled&ep=mcard";

  return (
    <section className="py-40 px-6 md:px-12 bg-brandBg relative overflow-hidden border-t border-zodiac/5">
      {/* Dynamic Background Glows */}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent rounded-full blur-[120px] animate-pulse-slow"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10 text-center">
        {/* Label */}
        <p className="text-[10px] font-black uppercase tracking-[0.5em] text-accent mb-8">
          READY TO SCALE
        </p>
        
        {/* Headline */}
        <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-zodiac mb-10 leading-[1.05] tracking-tighter">
          Prove How Decisions <br className="hidden md:block" /> Turn Into Action.
        </h2>
        
        {/* Subhead */}
        <p className="text-xl md:text-2xl text-zodiac/60 mb-16 max-w-3xl mx-auto font-light leading-relaxed">
          Validate execution on your real operations through a guided Live Trial or Enterprise Pilot starting with a qualification call.
        </p>
        
        {/* Primary CTA - High Impact Dual-Stack Button */}
        <div className="flex justify-center">
          <button 
            onClick={() => window.open(BOOKING_URL, '_blank')}
            className="w-full sm:w-auto bg-zodiac text-white px-10 py-6 md:px-16 md:py-8 rounded-[2rem] shadow-2xl hover:bg-accent transition-executive flex flex-col items-center gap-2 group hover:scale-[1.02] active:scale-[0.98]"
          >
            <span className="font-black text-xs md:text-sm uppercase tracking-[0.3em] transition-colors">
              Book a Validation Call
            </span>
            <span className="text-[10px] md:text-xs text-white/50 font-medium tracking-wide group-hover:text-white/80 transition-colors">
              Assess fit for a Live Trial or Enterprise Pilot
            </span>
          </button>
        </div>
        
        {/* Secondary Pilot Context */}
        <div className="mt-12 flex items-center justify-center gap-4 text-zodiac/20">
          <div className="h-px w-8 bg-current"></div>
          <span className="text-[9px] font-black uppercase tracking-[0.4em]">Qualification Session Required</span>
          <div className="h-px w-8 bg-current"></div>
        </div>
      </div>
    </section>
  );
};
